import React, { useEffect, lazy, useState } from 'react';
import { useForm } from 'react-hook-form';
import { ModalHeader, ModalBody, ModalFooter, Button, Row, Col } from 'reactstrap';
import 'react-datetime/css/react-datetime.css';
import { useTranslation } from 'react-i18next';
import FormTextArea from '../ReactHookFormCustom/FormTextArea';
import FormSwitch from '../ReactHookFormCustom/FormSwitch';
import FormInput from '../ReactHookFormCustom/FormInput';
import SendTestEmailModal from '../shared/sendTestEmailForm';
import useAuthStore from '../../../../stores/authStore';

const Modal = lazy(() => import('reactstrap/lib/Modal'));

const ConfigureEmailModal = ({
  isEmailModalOpen,
  toggleIsEmailModalOpen,
  selectedColumn,
  updateEmailSettings,
  hideAutomatedSendingOption,
}) => {
  const { t } = useTranslation();

  const globalUser = useAuthStore((state) => state.user);
  const [isTestEmailModalOpen, setIsTestEmailModalOpen] = useState(false);

  const initialValues = {
    switchButton: selectedColumn?.sendAutomatedEmail,
    kanbanEmailSubject: selectedColumn?.emailSubject,
    emailContent: selectedColumn?.emailContent,
  };

  const { handleSubmit, reset, control, watch } = useForm({
    defaultValues: initialValues,
  });

  useEffect(() => {
    reset({
      switchButton: selectedColumn?.sendAutomatedEmail,
      kanbanEmailSubject: selectedColumn?.emailSubject,
      emailContent: selectedColumn?.emailContent,
    });
  }, [selectedColumn]);

  const handleValidSubmit = (data) => {
    updateEmailSettings(selectedColumn?.id, data.switchButton, data.kanbanEmailSubject, data.emailContent);
    toggleIsEmailModalOpen();
  };

  const sendTestEmail = () => {
    setIsTestEmailModalOpen(true);
  };

  return (
    <>
      <SendTestEmailModal
        showModal={isTestEmailModalOpen}
        closeModal={() => setIsTestEmailModalOpen(false)}
        emailAddress={globalUser?.email}
        subject={watch('kanbanEmailSubject')}
        content={watch('emailContent')}
      />
      <Modal isOpen={isEmailModalOpen} centered>
        <ModalHeader>
          <h3 className="d-flex align-items-center">
            <i className="fa icon-envelope mr-2" />
            {t('kanban.EMAIL_CONFIGURATION')}
          </h3>
        </ModalHeader>
        <form onSubmit={handleSubmit(handleValidSubmit)}>
          <ModalBody>
            {!hideAutomatedSendingOption && (
              <Row>
                <Col>
                  <FormSwitch
                    control={control}
                    name="switchButton"
                    id="switchButtonId"
                    label={t('kanban.SEND_AUTOMATED_EMAIL')}
                  />
                </Col>
              </Row>
            )}

            <Row>
              <Col>
                <FormInput
                  control={control}
                  name="kanbanEmailSubject"
                  id="kanbanEmailSubjectId"
                  label={t('kanban.SUBJECT')}
                  rules={{ required: t('common.REQUIRED') }}
                />
              </Col>
            </Row>
            <Row className="pt-2">
              <Col>
                <FormTextArea
                  control={control}
                  name="emailContent"
                  id="emailContentId"
                  label={t('email.CONTENT')}
                  maxLength={1000}
                  rules={{ required: t('common.REQUIRED') }}
                />
                <span className="text-muted text-left">
                  {t('email.REPLACEMENT_MESSAGE')}
                  <a onClick={sendTestEmail} style={{ cursor: 'pointer', color: '#007bff' }}>
                    {t('email.SEND_TEST_EMAIL')}.
                  </a>
                </span>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button color="primary">{t('common.SAVE')}</Button>
            <Button color="secondary" onClick={toggleIsEmailModalOpen}>
              {t('common.CANCEL')}
            </Button>
          </ModalFooter>
        </form>
      </Modal>
    </>
  );
};

export default ConfigureEmailModal;
